// extracted by mini-css-extract-plugin
export default {"row":"viewStore_row__ffEFI","col":"viewStore_col__lJkIh","card":"viewStore_card__HgMkS"};